/**
 * Partnerships Tour
 *
 * Introduces users to partner management — directory, referrals,
 * agreements, and commission tracking.
 */

import type { TourConfig } from './tour-config.types';

export const partnershipsTour: TourConfig = {
  id: 'partnerships-overview',
  title: 'tours.partnerships.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="partners-list"]',
      content: 'tours.partnerships.steps.partnerDirectory',
      placement: 'bottom',
      route: '/partners',
    },
    {
      target: '[data-astor-id="partnerships-referrals"]',
      content: 'tours.partnerships.steps.referrals',
      placement: 'bottom',
      route: '/partnerships/referrals',
    },
    {
      target: '[data-astor-id="partnerships-agreements"]',
      content: 'tours.partnerships.steps.agreements',
      placement: 'bottom',
      route: '/partnerships/agreements',
    },
    {
      target: '[data-astor-id="partnerships-commissions"]',
      content: 'tours.partnerships.steps.commissions',
      placement: 'bottom',
      route: '/partnerships/commissions',
    },
  ],
};
